const DEFAULT_APP_BASE_PATH = '/unicom'

const getCurrentPathname = () => {
  return typeof window === 'undefined' ? '' : window.location.pathname
}

/**
 * 从当前页面匹配到对应的路径前缀
 * @returns {string} /wxyhh/unicom
 */
export const getBaseStartPathname = () => {
  const tempBasePathMatch = location.pathname.match(/^.*?\/unicom(?=\/|$)/)
  return tempBasePathMatch ? tempBasePathMatch[0] : DEFAULT_APP_BASE_PATH
}

/**
 * 去掉 /unicom 或 /xxx/unicom 的前缀
 * @param {string} [pathname] /wxyhh/unicom/login
 * @returns {string} /login
 */
export const getVueRoutePathname = (pathname = getCurrentPathname()) => {
  return String(pathname).replace(/^\/(?:[^/]+\/)?unicom(?=\/|$)/, '') || '/'
}

/**
 * 从完整 URL 中提取 /unicom 后的 Vue Router 路径，忽略 query 和 hash。
 * @param {string} [url] www.baidu.com/wxyhh/unicom/login
 * @returns {string} /login
 */
export const getVueRoutePathnameFromUrl = (url = '') => {
  const tempPathname = url.split(/[?#]/)[0]
  const tempRoutePathMatch = tempPathname.match(/\/unicom(\/.*)?$/)
  if (!tempRoutePathMatch) return tempPathname
  return tempRoutePathMatch[1] || '/'
}

/**
 * 拼接 /unicom 或 /xxx/unicom 的前缀
 * @param {string} [routePath] /login
 * @returns {string} /xxx/unicom/login
 */
export const getFullPathname = (routePath = '') => {
  const tempBasePath = getBaseStartPathname()
  return tempBasePath + routePath
}
